export const SAFAI_ACCEPTED_TYPES = ["image/png", "image/jpeg", "image/jpg"];
export const SAFAI_MAX_BYTES = 5 * 1024 * 1024;

export function validateSafaiFile(file: File): string | null {
  if (!SAFAI_ACCEPTED_TYPES.includes(file.type)) {
    return "Only PNG and JPEG images are allowed";
  }
  if (file.size > SAFAI_MAX_BYTES) {
    return "Image must be 5 MB or smaller";
  }
  return null;
}
